import { type Control, type FieldPath, type FieldValues, useController } from 'react-hook-form';
import { FormField } from './form-field';
import { SelectInput } from './select-input';
import type { SelectOption } from './select-options';

/** Lista de escolha com rótulo, dica e erro, ligada ao React Hook Form. */
export function SelectField<
  T extends FieldValues,
  N extends FieldPath<T>,
  TOut extends FieldValues = T,
>({
  control,
  name,
  label,
  hint,
  required,
  options,
  emptyLabel,
  placeholder,
  disabled,
  className,
}: {
  control: Control<T, unknown, TOut>;
  name: N;
  label: string;
  hint?: string;
  required?: boolean;
  options: SelectOption[];
  emptyLabel?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}) {
  const { field, fieldState } = useController({ control, name });
  return (
    <FormField
      label={label}
      hint={hint}
      required={required}
      className={className}
      error={fieldState.error?.message}
    >
      {(a11y) => (
        <SelectInput
          {...a11y}
          value={(field.value as string | undefined) ?? ''}
          onValueChange={(value) => {
            field.onChange(value);
            field.onBlur();
          }}
          options={options}
          emptyLabel={emptyLabel}
          placeholder={placeholder}
          disabled={disabled}
        />
      )}
    </FormField>
  );
}
